'use client';

import { X } from 'lucide-react';

import { useHeaderStore } from '@lib/stores/useHeaderStore';

export function ExpandedMenuClose() {
  const { setOpenSheet } = useHeaderStore();

  return (
    <button
      type='button'
      className='-m-2 inline-flex items-center justify-center rounded-md p-2 text-foreground/40'
      onClick={() => setOpenSheet(false)}
    >
      <span className='sr-only'>Close menu</span>
      <X className='size-6' aria-hidden='true' />
    </button>
  );
}
